module.exports = __webpack_public_path__ + "img/logo-fr.b8e72489.png";